import { Box, Typography, CircularProgress } from 'src/components';

export default function DrawerHeader({title, onBack, backText = 'Cancel', showBack = true, isLoading }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        my: 0.5,
        width: '100%',
      }}>

      {showBack ? (
        <Typography
          onClick={onBack}
          variant="subtitle1"
          sx={{
            cursor: 'pointer',
            color: 'primary.main',
            fontWeight: 600,
            ml: 3,
            lineHeight: 1.3
          }}
        >
          {backText}
        </Typography>
      ) : (
        <Box width="64px" /> // Keeps alignment when no back button
      )}

      {isLoading ? (
        <Box sx={{display: 'flex', alignItems: 'center'}}>
          <CircularProgress size={12} thickness={4} sx={{mr:1}} />
          <span>Loading Map Route</span>
        </Box>
      )
      : (
        <Typography variant="h5" textAlign="center" flex={1}>
          {title}
        </Typography>
      )}

      <Box width="64px" /> {/* Spacer to balance Cancel/back */}
    </Box>
  );
}
